<template>
  <div class="warp">
    <!-- <div :v-html="detail"></div> -->
    <iframe
      src="https://k12.yunpengai.com/agreement.html"
      frameborder="0"
      style="width: 100%; height: 100vh"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // detail: "https://k12.yunpengai.com/agreement.html",
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.warp {
  padding: 10px;
  width: 100%;
  min-height: 100vh;
  background: #f7f8fa;
  overflow: auto;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    text-align: center;
  }
  .content {
    font-size: 14px;
    text-indent: 2em;
    line-height: 21px;
    // color:;
  }
}
</style>